export const oceanEmailConfig = {
    shippingAdvice: [
        [
            {
                title: 'SHIPPER/ CONSIGNEE',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_trade_partner_id_shipper',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_trade_partner_id_consignee',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'SHIPMENT REF#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'reference',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'EX FACTORY/ VOLUME',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: '',
                description: null,
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'volume',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'POL/ ETD',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_pol',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'etd',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'POD/ ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_pod',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'eta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'ESTIMATED\n DELIVERY DATE',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'deta',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
    ],
    preAlert: [
        [
            {
                title: 'MBL#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'mbl',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'HBL#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'hbl',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'VESSEL NAME',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_opus_vessel_id',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'VOLUME/ CNTR#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'volume',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'cntr_number',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'POL/ ETD',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_pol',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'etd',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'POD/ ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_pod',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'eta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'FINAL DEST/ ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_fpod',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'feta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'DELIVERY/ ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_deliver_to',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'deta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'OTHERS INFO',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'reference',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
    ],
    statusUpdate: [
        [
            {
                title: 'CUSTOMER REF#',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                flexGrow: 1,
                component: 'th',
            },
            {
                title: 'HBL#',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },
            {
                title: 'CNTR#',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },
            {
                title: 'VOLUME',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },
            {
                title: 'POL/ ETD',
                description: null,
                style: 'headerStyle_status',
                colSpan: 2,
                component: 'th',
            },
            {
                title: 'POD/ ETA',
                description: null,
                style: 'headerStyle_status',
                colSpan: 2,
                component: 'th',
            },
            {
                title: 'FPOD/ FETA',
                description: null,
                style: 'headerStyle_status',
                colSpan: 2,
                component: 'th',
            },
            {
                title: 'CURRENT NEWEST STATUS',
                description: null,
                style: 'headerStyle_statusMessage',
                colSpan: 1,
                component: 'th',
            },
        ],
        [
            {
                title: null,
                description: 'hbl_reference',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'hbl_number',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'cntr_number',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'volume',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_location_id_pol',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'etd',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_location_id_pod',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'eta',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_location_id_fpod',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'feta',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: null,
                style: 'tableCellStyle_statusMessage',
                colSpan: 1,
            },
        ],
    ],
};

/**
 * Build a config whose STATUS UPDATE table has one column inserted, replaced, or removed.
 * The header row is anchored by anchorTitle and the data row by anchorDescription;
 * position is one of 'before' | 'after' | 'replace' | 'remove'.
 * 'replace' swaps the anchor column for the new one; 'remove' drops it (title/description not needed).
 */
const withStatusColumn = (base, { anchorTitle, anchorDescription, position, title, description }) => {
    const place = (item, cell) => {
        if (position === 'before') return [item, cell];
        if (position === 'replace') return [item];
        if (position === 'remove') return [];
        return [cell, item];
    };
    const insert = (row, isAnchor, item, anchorLabel) => {
        if (!row.some(isAnchor)) {
            // A silent miss would render the table without the column; fail loudly at module load instead.
            throw new Error(`withStatusColumn: anchor ${JSON.stringify(anchorLabel)} not found in STATUS UPDATE row`);
        }
        return row.flatMap((cell) => (isAnchor(cell) ? place(item, cell) : [cell]));
    };
    return {
        ...base,
        statusUpdate: base.statusUpdate.map((row) =>
            row.every((cell) => !!cell.title)
                ? insert(
                      row,
                      (cell) => cell.title === anchorTitle,
                      { title, description: null, style: 'headerStyle_status', colSpan: 1, component: 'th' },
                      anchorTitle,
                  )
                : insert(
                      row,
                      (cell) => cell.description === anchorDescription,
                      { title: null, description, style: 'tableCellStyle_status', colSpan: 1 },
                      anchorDescription,
                  ),
        ),
    };
};

/**
 * Ocean Import: DELIVERY LOCATION to the right of FPOD/ FETA.
 * The value is delivery_location, built per container by emailDataBuilder (alias Delivery To values joined with "/ ").
 */
export const oceanImportEmailConfig = withStatusColumn(oceanEmailConfig, {
    anchorTitle: 'FPOD/ FETA',
    anchorDescription: 'feta',
    position: 'after',
    title: 'DELIVERY LOCATION',
    description: 'delivery_location',
});

/**
 * Ocean Export: PICK UP LOCATION to the left of POL/ ETD.
 * The value is the container's Pick Up (il_location_id_pick_up). Export has no alias.
 */
export const oceanExportEmailConfig = withStatusColumn(oceanEmailConfig, {
    anchorTitle: 'POL/ ETD',
    anchorDescription: 'il_location_id_pol',
    position: 'before',
    title: 'PICK UP LOCATION',
    description: 'il_location_id_pick_up',
});

export const airEmailConfig = {
    shippingAdvice: [
        [
            {
                title: 'SHIPPER/ CONSIGNEE',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_trade_partner_id_shipper',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_trade_partner_id_consignee',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'SHIPMENT REF#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'reference',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'EX FACTORY/ VOLUME',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: '',
                description: null,
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'quantity',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'AOL/ ETD',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_aol',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'etd',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'AOD/ ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_aod',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'eta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'ESTIMATED DELIVERY DATE',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'deta',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
    ],
    preAlert: [
        [
            {
                title: 'MAWB#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'mawb',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'HAWB#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'hawb',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'FLIGHT#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_opus_vessel_id',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'VOLUME',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'quantity',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'AOL/ETD',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_aol',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'etd',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'AOD/ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_aod',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'eta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'FINAL DEST/ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_faod',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'feta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'DELIVERY/ ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_deliver_to',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'deta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'OTHERS INFO',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'reference',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
    ],
    statusUpdate: [
        [
            {
                title: 'CUSTOMER REF#',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },
            {
                title: 'HAWB#',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },

            {
                title: 'FLIGHT#',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },
            {
                title: 'AOL/ETD',
                description: null,
                style: 'headerStyle_status',
                colSpan: 2,
                component: 'th',
            },
            {
                title: 'AOD/ETA',
                description: null,
                style: 'headerStyle_status',
                colSpan: 2,
                component: 'th',
            },
            {
                title: 'ESTIMATED\nDELIVERY DATE',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },
            {
                title: 'CURRENT NEWEST\n STATUS',
                description: null,
                style: 'headerStyle_statusMessage',
                colSpan: 1,
                component: 'th',
            },
        ],
        [
            {
                title: null,
                description: 'hbl_reference',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'hawb_number',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },

            {
                title: null,
                description: 'il_opus_vessel_id',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_location_id_aol',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'etd',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_location_id_aod',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'eta',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'deta',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: null,
                style: 'tableCellStyle_statusMessage',
                colSpan: 1,
            },
        ],
    ],
};

/**
 * Air Import: replace the ESTIMATED DELIVERY DATE column with DELIVERY LOCATION.
 * The value is delivery_location, built per alias row by emailDataBuilder (the alias's Delivery To).
 */
export const airImportEmailConfig = withStatusColumn(airEmailConfig, {
    anchorTitle: 'ESTIMATED\nDELIVERY DATE',
    anchorDescription: 'deta',
    position: 'replace',
    title: 'DELIVERY LOCATION',
    description: 'delivery_location',
});

/**
 * Air Export: drop the ESTIMATED DELIVERY DATE column (Export has no Delivery Location field)
 * and add PICK UP LOCATION (the alias's Pick Up) to the left of AOL/ETD. Only STATUS UPDATE changes.
 */
export const airExportEmailConfig = withStatusColumn(
    withStatusColumn(airEmailConfig, {
        anchorTitle: 'ESTIMATED\nDELIVERY DATE',
        anchorDescription: 'deta',
        position: 'remove',
    }),
    {
        anchorTitle: 'AOL/ETD',
        anchorDescription: 'il_location_id_aol',
        position: 'before',
        title: 'PICK UP LOCATION',
        description: 'il_location_id_pick_up',
    },
);

export const truckingEmailConfig = {
    shippingAdvice: [
        [
            {
                title: 'SHIPPER/CONSIGNEE',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_trade_partner_id_shipper',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_trade_partner_id_consignee',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'SHIPMENT REF#',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'reference',
                style: 'tableCellStyle',
                colSpan: 2,
            },
        ],
        [
            {
                title: 'EX FACTORY/ VOLUME',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: '',
                description: null,
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'quantity',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'LOADING/ETD',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_pick_up',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'etd',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
        [
            {
                title: 'DELIVERY/ETA',
                description: null,
                style: 'headerStyle',
                colSpan: 1,
                component: 'th',
            },
            {
                title: null,
                description: 'il_location_id_deliver_to',
                style: 'tableCellStyle',
                colSpan: 1,
            },
            {
                title: null,
                description: 'eta',
                style: 'tableCellStyle',
                colSpan: 1,
            },
        ],
    ],
    statusUpdate: [
        [
            {
                title: 'CUSTOMER REF#',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },
            {
                title: 'BOL#',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },

            {
                title: 'TRUCKER',
                description: null,
                style: 'headerStyle_status',
                colSpan: 1,
                component: 'th',
            },
            {
                title: 'LOADING/ETD',
                description: null,
                style: 'headerStyle_status',
                colSpan: 2,
                component: 'th',
            },
            {
                title: 'DELIVERY/ETA',
                description: null,
                style: 'headerStyle_status',
                colSpan: 2,
                component: 'th',
            },
            {
                title: 'CURRENT NEWEST\n STATUS',
                description: null,
                style: 'headerStyle_statusMessage',
                colSpan: 1,
                component: 'th',
            },
        ],
        [
            {
                title: null,
                description: 'reference',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'bol',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_trade_partner_id_client',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_location_id_pick_up',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'etd',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'il_location_id_deliver_to',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },
            {
                title: null,
                description: 'eta',
                style: 'tableCellStyle_status',
                colSpan: 1,
            },

            {
                title: null,
                description: null,
                style: 'tableCellStyle_statusMessage',
                colSpan: 1,
            },
        ],
    ],
};
